import { useMutation } from "urql";

const useDeleteMutation = (mutation) => {
  const [response, deleteById] = useMutation(mutation);
  const remove = (id) => deleteById({ id });
  return [response, remove];
};

export default useDeleteMutation;
